import { render, staticRenderFns } from "./leaderboard-highlights.vue?vue&type=template&id=2faea44c&scoped=true&"
import script from "./leaderboard-highlights.vue?vue&type=script&lang=js&"
export * from "./leaderboard-highlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faea44c",
  null
  
)

export default component.exports